module.exports = __webpack_public_path__ + "static/img/sec 3.85fd039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/sec 3.png
// module id = ijeD
// module chunks = 12